import type { ColumnDefinition } from "../../../ui/components/Table/types";
import type { SmartLinkProductLink } from "../../lib/api/smart-link";
import type { TranslateValues } from "../../lib/i18n";
import { SmartLinkSyncStatusBadge } from "../../../ui/components/SmartLinkSyncStatusBadge";
import { StatusBadge } from "../../../ui/components/StatusBadge";

function formatDate(value: string | null): string {
  if (!value) return "—";
  return new Date(value).toLocaleString();
}

export function createSmartLinkProductsTableColumns(
  t: (key: string, values?: TranslateValues) => string,
): ColumnDefinition<SmartLinkProductLink>[] {
  return [
    {
      id: "name",
      label: t("pro.system.smartLink.products.col.product"),
      pinnedLeft: true,
      render: (row) => row.product.name,
    },
    {
      id: "serial",
      label: t("pro.system.smartLink.products.col.serial"),
      render: (row) => row.product.serial ?? "—",
    },
    {
      id: "linkStatus",
      label: t("pro.system.smartLink.col.linkStatus"),
      render: (row) =>
        row.linkEnabled ? (
          <StatusBadge variant="online" size="sm" label={t("pro.system.smartLink.status.linked")} />
        ) : (
          <StatusBadge variant="offline" size="sm" label={t("pro.system.smartLink.status.disabled")} />
        ),
    },
    {
      id: "syncStatus",
      label: t("pro.system.smartLink.col.syncStatus"),
      render: (row) => <SmartLinkSyncStatusBadge status={row.syncStatus} label={t("pro.system.smartLink.badge")} />,
    },
    {
      id: "lastSyncedAt",
      label: t("pro.system.smartLink.col.lastSynced"),
      sortable: true,
      render: (row) => formatDate(row.lastSyncedAt),
    },
  ];
}
